import { render, staticRenderFns } from "./ViewModalPayment.vue?vue&type=template&id=27396ff1&scoped=true&"
import script from "./ViewModalPayment.vue?vue&type=script&lang=ts&"
export * from "./ViewModalPayment.vue?vue&type=script&lang=ts&"
import style0 from "./ViewModalPayment.vue?vue&type=style&index=0&id=27396ff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27396ff1",
  null
  
)

export default component.exports